import { createSourcingRequestEmbeddedConfig } from './sourcing-request-embedded.factory';

/**
 * Sourcing Request embedded list — scoped to a single vendor (via line
 * vendor assignments). Mounted on the Vendor Detail "Sourcing Requests"
 * tab. The line-level vendor filter is applied at the tab/queryFn layer
 * (`sourcingRequestLineVendor`).
 */
export const SOURCING_REQUEST_VENDOR_EMBEDDED_CONFIG =
	createSourcingRequestEmbeddedConfig({
		id: 'default-sourcing-requests-vendor-embedded',
		name: 'Vendor Sourcing Requests',
	});
